import { createFileRoute } from '@tanstack/react-router';
import { redirectToPasswordEditor } from './-team-set-password-redirect';

export const Route = createFileRoute('/_authenticated/settings/team/set_password')({
  beforeLoad: redirectToPasswordEditor,
});
